import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventService } from '../../../services/event.service';
import { PlayerService } from 'src/app/services/player.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { Router } from '@angular/router';
import { Player } from 'src/app/objects/player';
import { MatButtonToggleGroup } from '@angular/material/button-toggle';
import { CoursesService } from 'src/app/services/courses.service';

@Component({
  selector: 's18-post-score-dialog',
  templateUrl: './post-score-dialog.component.html',
  styleUrls: ['./post-score-dialog.component.scss']
})
export class PostScoreDialogComponent implements OnInit {
  @ViewChild('nbrOfHolesGroup', { static: true }) nbrOfHoles: MatButtonToggleGroup;
  @ViewChild('roundTypeGroup', { static: true }) roundTypeGroup: MatButtonToggleGroup;
  @ViewChild('entryType', { static: true }) entryType: MatButtonToggleGroup;



  player_id: string;
  player: Player;
  error: string;
  holeByHole: boolean = false;
  sending: boolean = false;
  searchingTees: boolean = false;
  searchingCourse: boolean = false;

  allStates: any[];
  courses: any[];
  tees: any[];
  date: string;
  eventState: string;
  eventCourseId: string;
  eventTeesId: string;
  escScore: string;
  course_name: string;
  slope: string;
  rating: string;

  constructor(
    private eventService: EventService,
    private courseService: CoursesService,
    private localStorageService: LocalStorageService,
    private playerService: PlayerService,
    private router: Router,
    private dialogRef: MatDialogRef<PostScoreDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.player_id = data.player_id;
    this.holeByHole = data.holeByHole;
    this.player = this.playerService.getLoggedInPlayerInfo();
  }

  ngOnInit() {
    this.courseService.getStates(this.data.player_id).subscribe(resp => this.parseStates(resp));
    this.nbrOfHoles.value = "18";
    this.entryType.value = "pick-course";
    this.roundTypeGroup.value = "H";
  }

  getCourses() {
    this.searchingCourse = true;
    this.courseService.getCoursesForState(this.eventState)
      .subscribe(resp => {
        this.courses = JSON.parse(resp.d).courses;
        this.searchingCourse = false;
      }, err => {
        this.searchingCourse = false;
      });
  }

  getTees() {
    this.searchingTees = true;
    this.courseService.getTeesForCourse(this.eventCourseId)
      .subscribe(resp => {
        this.tees = JSON.parse(resp.d).tees;
        this.searchingTees = false;
      }, err => {
        this.searchingTees = false;
      });
  }

  parseStates(resp: any) {
    this.allStates = JSON.parse(resp.d).states;
  }

  createEvent() {
    var course = this.courses.find(x => x.course_id == this.eventCourseId);
    var group_id = this.localStorageService.get('adminGroups')[0].group_id;
    this.eventService.createEvent(this.date, "00:00:00", course.coursename, group_id, this.eventCourseId, this.eventTeesId, "1", this.nbrOfHoles.value)
      .subscribe(resp => {
        var groupEventInfo = JSON.parse(resp.d);
        this.addPlayerToEvent(groupEventInfo.event_info);
      }, err => {
        this.error = err;
        this.sending = false;
      });
  }

  addPlayerToEvent(groupEventInfo) {
    var player = this.playerService.getLoggedInPlayerInfo();
    this.eventService.addPlayerToEvent(groupEventInfo.group_event_id, player.player_id.toString(), true)
      .subscribe(resp => {
        if (this.player.subscription_id) {
          this.router.navigateByUrl("/event/stats/" + groupEventInfo.group_event_id);
        } else {
          this.router.navigateByUrl("/event/verify/" + groupEventInfo.group_id + "/" + groupEventInfo.group_event_id);
        }
        this.dialogRef.close();
      }, err => {
        this.error = err;
        this.sending = false;
      });
  }

  postScore() {
    this.sending = true;
    if (this.holeByHole) {
      this.createEvent();
      return;
    }
    this.error = "";

    if (this.entryType.value === "pick-course") {
      this.eventService.postScore(this.player_id, this.date, this.eventCourseId, this.eventTeesId, this.escScore, this.roundTypeGroup.value, this.nbrOfHoles.value)
        .subscribe(resp => {
          this.processPostResponse(resp);
        }, err => {
          this.sending = false;
        });
    }
    else {
      this.eventService.postScoreManually(this.player_id, this.date, this.course_name, this.slope, this.rating, this.escScore, this.roundTypeGroup.value, this.nbrOfHoles.value)
        .subscribe(resp => {
          this.processPostResponse(resp);
        }, err => {
          this.sending = false;
        });
    }
  }

  processPostResponse(resp) {
    var response = JSON.parse(resp.d).response;
    if (response === 'ok') {
      this.dialogRef.close("success");
    } else {
      this.sending = false;
      this.error = response;
    }
  }

}
